<template>
  <div class="profile__block__content profile__block__content--theme-performance">
    <div class="theme-cont generic-carousel theme-carousel">
      <div v-for="(theme, index) in orderedThemes" :key="index" class="theme-cont__icon">
        <img :src="theme.iconUrl" alt="">
        <span :style="{color: 'rgb(' + theme.red +','+ theme.green +','+ theme.blue +')'}">{{theme.score}}%</span>
      </div>
    </div>
    <div class="carousel__nav"></div>
  </div>
</template>

<script>
/* eslint no-param-reassign: ["error", { "props": false }], no-console: "off" */
import { mapGetters } from 'vuex';
import 'owl.carousel';

export default {
  name: 'theme-performance',
  props: {
    themeStats: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      themes: [],
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      /* eslint-disable */
      this.$nextTick(() => {
        $('.theme-carousel').owlCarousel({
          loop: false,
          responsiveClass: true,
          dots: true,
          autoplay: false,
          autoplayTimeout: 5000,
          autoplayHoverPause: true,
          navContainer: '.carousel__nav',
          dotsContainer: '.carousel__dots',
          navText: ['<i   class="icon-arrow-left"></i>', '<i class="icon-arrow-right"></i>'],
          responsive: {
            0: {
              items: 4,
              nav: true,
              onInitialized: function() {
                $(".icon-arrow-left").addClass("deactivated");
              },
              onTranslated: function(event){
                $('.icon-arrow-right').removeClass('deactivated');
                $('.icon-arrow-left').removeClass('deactivated');
                if (event.item.index == 0){
                  $(".icon-arrow-left").addClass("deactivated");
                } else {
                  $(".icon-arrow-left").show();
                }
                if (event.item.index == (event.item.count - 4)){
                  $(".icon-arrow-right").addClass("deactivated");
                }
                else {
                  $(".icon-arrow-right").show();
                }
              }
            },
          },
        })
      });
      /* eslint-enable */
    },
    computeScore() {
      this.themes = JSON.parse(JSON.stringify(this.themeStats));
      this.themes.forEach((element) => {
        element.score = Math.round((element.totalCorrectAnswers / element.totalAnswers) * 100);
      });
    },
  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
    orderedThemes() {
      this.computeScore();
      // sort games by date ascending
      return this.themes.slice(0).sort((a, b) => b.score - a.score);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/profile/ThemePerformance.vue